import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemAttachmentsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-attachments',
	path: '/secure/admin/ViewAttachmentSettings.jspa',
};
